import React from "react";

import useNavigation from "../../hooks/useNavigation";

import SchoolMobileViewHeader from "../components/SchoolMobileViewHeader";
import SchoolMobileListItem from "../components/SchoolMobileListItem";

const SchoolMobileMegaMenuView = ({ view }) => {
  const { pushView } = useNavigation();

  const { title, data } = view;

  return (
    <div className="school-mobile-mega-menu-view">

      <SchoolMobileViewHeader title={title} />

      {data.sections.map((section) => (
        <SchoolMobileListItem
          key={section.id}
          label={section.title}
          hasChildren
          onClick={() =>
            pushView({
              type: "section",
              title: section.title,
              data: section,
            })
          }
        />
      ))}

    </div>
  );
};

export default SchoolMobileMegaMenuView;